import { ShieldAlert } from "lucide-react";

const AcessoInvalido = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[80vh] text-center text-gray-700">
      <ShieldAlert className="w-20 h-20 text-yellow-500 mb-6" />
      <h1 className="text-4xl font-bold mb-2">Acesso Inválido</h1>
      <p className="text-lg text-gray-600">
        O link que você tentou acessar é inválido ou expirou.
      </p>
      <p className="text-md text-gray-500 mt-1">
        Por favor, utilize o link fornecido originalmente.
      </p>
    </div>
  );
};

export default AcessoInvalido;
